export default __webpack_public_path__ + "navigation-examples-embedded-navigation-1200-0a3486b0c748d116d20ae1cf1f13e9d4.png";